module.exports = new __parcel__URL__("6562.e52159a6.jpg").toString();